<!-- 图片收集题：主卡片  -->
<template>
  <!-- 添加 filed-item-drag-group 样式支持可拖动排序 -->
  <div class="image-card filed-item-drag-group">
    <!-- 序号及标题 -->
    <div class="image-card__hd">
      <span class="must-star" v-if="isMust">*</span>
      <span class="label">{{ seq | numFormmat }}.</span>
      <vh-input
        :maxlength="itemData.maxlength ? itemData.maxlength : 100"
        autocomplete="off"
        show-word-limit
        :placeholder="languageType == 2 ? $t('lang.k_381001') : $t('lang.k_381002')"
        v-model="itemData.label"
        class="radioInput titleInput"
      ></vh-input>
    </div>
    <!-- 图片上传 -->
    <div class="image-card__bd">
      <ImageUploadPlace :languageType="languageType" />
    </div>

    <!-- 底部栏 -->
    <div class="image-card__ft bottomBtn">
      <div class="controlBtnBox">
        <vh-tooltip
          class="item"
          effect="dark"
          :content="$t('lang.k_381003')"
          placement="top"
          v-tooltipMove
        >
          <i class="iconfont-v3 saasicon-trash" @click="handleDelete"></i>
        </vh-tooltip>
        <vh-tooltip
          class="item"
          effect="dark"
          :content="$t('lang.k_381004')"
          placement="top"
          v-tooltipMove
        >
          <i class="iconfont-v3 saasicon_move moveBtn"></i>
        </vh-tooltip>
      </div>
    </div>
  </div>
</template>
<script>
  import ImageUploadPlace from './ImageUploadPlace.vue';

  export default {
    name: 'ImageProblem',
    components: {
      ImageUploadPlace
    },
    data() {
      return {
        imageUrl: ''
      };
    },
    props: {
      isMust: Boolean,
      // 1 中文，2：英文, 默认为 1
      languageType: {
        type: [Number, String],
        default: 1
      },
      seq: Number,
      itemData: {
        type: Object,
        required: true,
        default() {
          return {};
        }
      },
      value: {
        type: Object,
        required: true,
        default() {
          return {};
        }
      }
    },
    filters: {
      numFormmat(val) {
        return val < 9 ? `0${val + 1}` : val + 1;
      }
    },
    methods: {
      // 删除整个隐私协议题目
      handleDelete() {
        this.$emit('on-delete', this.itemData.question_id, this.itemData);
      }
    }
  };
</script>
<style lang="less" scoped>
  .image-card {
    .must-star {
      position: absolute;
      left: 15px;
      color: red;
      padding-top: 8px;
      font-size: 20px;
    }
    &__hd {
      display: flex;
      flex-direction: row;
      align-items: center;
    }
    &__bd {
    }
    &__ft {
      margin-top: 9px;
      text-align: right;
      overflow: hidden;

      .controlBtnBox {
        display: inline-flex;
        height: 20px;
        line-height: 20px;
        float: right;
        i {
          font-size: 18px;
          color: #666666;
          margin-left: 16px;
          cursor: pointer;
        }
      }
    }
  }
</style>
